module.exports = {"371728001":"城关街道","371728002":"渔沃街道","371728101":"东明集镇","371728102":"刘楼镇","371728103":"陆圈镇","371728104":"马头镇","371728105":"三春集镇","371728106":"大屯镇","371728107":"武胜桥镇","371728108":"菜园集镇","371728109":"沙窝镇","371728110":"小井镇","371728204":"长兴集乡","371728205":"焦园乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371728.json
// module id = 1629
// module chunks = 0